import { render } from "./AnswerArea.vue?vue&type=template&id=492b5443&scoped=true"
import script from "./AnswerArea.vue?vue&type=script&lang=js"
export * from "./AnswerArea.vue?vue&type=script&lang=js"

import "./AnswerArea.vue?vue&type=style&index=0&id=492b5443&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492b5443"]])

export default __exports__